module.exports = __webpack_public_path__ + "img/booked_icon.9f9b09cd.svg";